var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.tables && _vm.data.tables.length)?_c('span',_vm._l((_vm.data.tables),function(table,index){return _c('span',{key:index},[_vm._v(" "+_vm._s(table.name)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }